import { MetricDeltaSecondary } from '../types';

// The only place a LIVE `MetricDelta.secondary` is constructed. It exists so the one rule that
// cannot be enforced by the type — that live data never states a percentage-POINT movement — has a
// single site to hold it, instead of being re-decided at each of the 27 cards.
//
// Why live can never emit `pp`: a percentage-point movement is the difference between two
// PERCENTAGES, so for a percentage metric it is already the primary delta (`unit: 'pp'`) and a
// second copy beside it would state the same quantity twice. For a count or a currency amount it is
// not a quantity at all. The `pp` secondaries the fixtures ship are screen readings copied from the
// design file, where one movement is printed beside five different bases — see
// `fixtures/__tests__/secondaryDelta.test.ts`. Those are design artefacts and must not be reachable
// from a payload.
//
// Derivability only. Whether the figure is DISPLAYED is a separate question the renderer answers
// (`components/Intelligence/PeriodDelta` draws it for count and currency deltas), so the two are not
// duplicated here. PLA-8815.
export const secondaryFor = (
  current: number,
  previous: number
): MetricDeltaSecondary | undefined => {
  // A movement against a zero or absent base is not a percentage of anything. Returning `undefined`
  // rather than 0 is the same rule the payload follows for an uncalculated reading: no figure at
  // all beats a figure that reads as measured (FR § Data states).
  if (!Number.isFinite(current) || !Number.isFinite(previous) || previous === 0) {
    return undefined;
  }

  return { value: ((current - previous) / previous) * 100, unit: 'percent' };
};

export default secondaryFor;
